<fieldset>
  <app-radio-input [name]="name" [control]="control" id="Radio1" [text]="options[0].label" [value]="options[0].value" />
  <app-radio-input [name]="name" [control]="control" id="Radio2" [text]="options[1].label" [value]="options[1].value"/>
  <app-radio-input [name]="name" [control]="control" id="Radio3" [text]="options[2].label" [value]="options[2].value"/>
</fieldset>
